import {
  faClock,
  faCoins,
  faEnvelope,
  faMapMarker,
  faPhone,
  faUser,
} from "@fortawesome/fontawesome-free-solid";
import {
  faCalendarWeek,
  faCarSide,
  faPen,
  faPlaneUp,
  faUserGroup,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DirectionsService } from "@react-google-maps/api";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ArrowCircleLeftIcon } from "@heroicons/react/solid";
import SearchResultHeading from "../../../components/b2c/SearchResultHeading";
import SideBar from "../../../components/b2b/SideBar";
import BookingDetailsItem from "../../../components/b2c/BookingDetailsItem";
import Header from "../../../components/landingPage/Header";
import Modal from "../../../components/b2b/Modal";
import {
  clearDestinationInput,
  clearSourceInput,
} from "../../../redux/app/map/map-slice";
import axios from "axios";

const BookingSummaryB2b = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { booking } = useSelector((state) => state.booking);
  const { passenger } = useSelector((state) => state.passenger);
  const { vehicle } = useSelector((state) => state.vehicle);
  const { token, user } = useSelector((state) => state.auth);
  const [editPen, seteditPen] = useState(false);
  let order_Data;

  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  const __DEV__ = document.domain === "localhost";

  async function displayRazorpay() {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const data = await fetch(
      `${process.env.REACT_APP_BASE_URL}/razorpay?amount=${Math.round(
        booking?.priceDetails?.amount
      )}&currency=${booking?.priceDetails?.currency}`,
      {
        method: "POST",
      }
    ).then((t) => t.json());

    order_Data = data;

    const options = {
      key: __DEV__
        ? "rzp_test_puo1xjdgc63ciU"
        : process.env.REACT_APP_RAZORPAY_KEY_ID,
      currency: data.currency,
      amount: data.amount.toString(),
      order_id: data.id,
      name: "Drivado",
      description: "A global chauffeur service",
      // image: 'http://localhost:1337/logo.svg',
      handler: function (response) {
        if (
          response.razorpay_payment_id &&
          response.razorpay_order_id &&
          response.razorpay_signature
        ) {
          dispatch({
            type: "CONFIRM_BOOKING_WITH_PAYMENT",
            payload: {
              body: {
                bookingId: booking.bookingId,
                bookingStatus: "CONFIRMED",
                paymentStatus: "PAID",
              },
              token,
              navigate,
            },
          });
        }
      },
      prefill: {
        name: passenger?.firstname + passenger.lastname,
        email: passenger.email,
        phone_number: passenger.phone,
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  // * razorpay end

  async function calculateRoute() {
    // eslint-disable-next-line no-undef
    // const directionsService = new google.maps.DirectionsService();
    // const directionsService = DirectionsService();

    const results = await DirectionsService.route({
      origin: booking?.source?.placename,
      destination: booking?.destination?.placename,
      // eslint-disable-next-line no-undef
      // travelMode: google.maps.TravelMode.DRIVING,
      travelMode: "DRIVING",
    });

    const result = DirectionsService.setDirectionsResponse(results);
    // setDistance(results.routes[0].legs[0].distance.text);
    // setDuration(results.routes[0].legs[0].duration.text);
  }

  const [priceUpdateInputState, setpriceUpdateInputState] = useState();

  const editPriceInBooking = () => {
    const body = {
      bookingId: booking?.bookingId,
      priceDetails: {
        amount: parseFloat(priceUpdateInputState),
        currency: booking?.priceDetails.currency,
      },
    };
    dispatch({
      type: "UPDATE_BOOKING",
      payload: { body, token },
    });
    seteditPen(false);
  };

  const payHandler = () => {
    displayRazorpay();
  };

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
      // window.location.pathname = "/newbooking";
    };
  }, []);

  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
    localStorage.setItem("relodePage", "true");
  };

  useEffect(() => {
    if (localStorage.getItem("relodePage")) {
      localStorage.removeItem("relodePage");
      navigate("/newbooking");
    }
  }, [navigate]);

  return (
    <div className="h-screen w-screen fixed">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-full overflow-y-auto h-[90vh] scrollbar pt-1 pb-8">
          <div className="sm:flex mt-5 sm:space-x-5 px-3">
            <div>
              <Link to="/newbooking">
                <ArrowCircleLeftIcon className="w-8 text-gray-600 my-1" />
              </Link>
            </div>
            <SearchResultHeading
              searchCompleted={true}
              chVehicleCompleted={true}
              passengerCompleted={true}
              bkSummaryCurrent={true}
              showBookingDetail={false}
            />
          </div>

          {editPen && (
            <>
              <Modal
                cancelOnClick={() => seteditPen(false)}
                addOnClick={editPriceInBooking}
                addButtonLabel="Save"
                heading="Edit Price"
                isPriceEditBookingSummary={true}
                priceUpdateInput={(e) => {
                  setpriceUpdateInputState(e.target.value);
                }}
                priceUpdate={priceUpdateInputState}
              />
              <div
                className="fixed inset-0 z-40 bg-black opacity-25"
                onClick={() => {
                  seteditPen(false);
                }}
              ></div>
            </>
          )}
          <div className="lg:flex mx-3 lg:mx-5 mt-8 scrollbar">
            {/* booking Summary */}
            <div className="w-full lg:w-2/3 lg:border-r-[1px] pr-1 lg:mr-2 xl:mr-6 mr-6">
              <div className="text-lg text-gray-500 font-semibold mb-2 border-b border-gray-500">
                Booking Details
              </div>
              <div className="rounded-sm py-2 space-y-2">
                <BookingDetailsItem
                  bookingSummery={true}
                  iconname={faMapMarker}
                  itemText={booking?.source?.placename}
                  label="Pick up"
                />
                {booking?.destination?.placename && (
                  <BookingDetailsItem
                    bookingSummery={true}
                    iconname={faMapMarker}
                    itemText={booking?.destination?.placename}
                    label="Drop off"
                  />
                )}
                <BookingDetailsItem
                  bookingSummery={true}
                  iconname={faCalendarWeek}
                  itemText={moment(booking?.travelDate?.split("T")[0]).format(
                    "DD MMM YYYY"
                  )}
                  label="Date"
                />{" "}
                <BookingDetailsItem
                  bookingSummery={true}
                  iconname={faClock}
                  itemText={booking?.travelTime}
                  label="Time"
                />{" "}
                <BookingDetailsItem
                  bookingSummery={true}
                  iconname={faCarSide}
                  itemText={
                    booking?.bookingType?.charAt(0)?.toUpperCase() +
                    booking?.bookingType?.slice(1).toLowerCase()
                  }
                  label="Boking Type"
                />{" "}
                <BookingDetailsItem
                  bookingSummery={true}
                  iconname={faClock}
                  itemText={booking?.duration}
                  label="Duration"
                />
                <BookingDetailsItem
                  bookingSummery={true}
                  iconname={faUserGroup}
                  itemText={booking?.passenger}
                  label="Passengers"
                />
                <div className="flex items-center space-x-5">
                  <BookingDetailsItem
                    bookingSummery={true}
                    iconname={faCoins}
                    itemText={
                      Math.round(booking?.priceDetails.amount) +
                      " " +
                      booking?.priceDetails.currency
                    }
                    label="Price"
                  />

                  {user?.role === "ADMIN" && (
                    <div
                      className="flex space-x-1.5 items-center cursor-pointer bg-[#fb4156] rounded-sm px-3 py-1 hover:bg-gray-300  hover:text-black"
                      onClick={() => {
                        seteditPen(true);
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPen}
                        className="w-3 h-3 text-white  hover:text-black"
                      />
                      <div className="text-sm text-white hover:text-black">
                        Edit
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-5 space-y-2">
                <div className="text-lg text-gray-500 mb-2 font-semibold border-b border-gray-500">
                  Passenger Details
                </div>
                <div className="space-y-2 pt-2">
                  <PassengerDetailItem
                    iconName={faUser}
                    label="Full Name"
                    text={passenger?.firstname + " " + passenger?.lastname}
                  />
                  <PassengerDetailItem
                    iconName={faPhone}
                    label="Contact No."
                    text={passenger.dial_code + " " + passenger.phone}
                  />
                  <PassengerDetailItem
                    iconName={faEnvelope}
                    label="Email"
                    text={passenger.email}
                  />
                  <PassengerDetailItem
                    iconName={faPlaneUp}
                    label="Flight  No."
                    text={passenger.flightOrTrain}
                  />
                </div>
              </div>
            </div>
            {/* map with distance */}

            <div className="w-full lg:w-1/3">
              <img
                src={
                  vehicle.image
                    ? vehicle.image
                    : vehicle?.vehicleImage?.secure_url
                }
                alt={vehicle.vehicleType}
                className="w-1/2 h-auto mx-auto mt-10"
              />
              <div className="mt-1 ml-5">
                <div className="flex lg:flex-row xl:flex space-x-2 items-center text-lg">
                  <div className="font-semibold uppercase text-base">
                    Vehicle Type:
                  </div>
                  <div className="font-semibold text-secondary">
                    {vehicle?.categoryType
                      ? vehicle?.categoryType
                      : vehicle.vehicleType
                      ? vehicle.vehicleType
                      : vehicle?.type}
                  </div>
                </div>
                <div>
                  <div className="flex space-x-2 items-center text-gray-500 text-sm">
                    {vehicle.description}
                  </div>
                </div>
              </div>
              <div className="flex space-x-3">
                {(!booking?.userName.includes("Offline") ||
                  user?.role !== "ADMIN") && (
                  <div
                    onClick={payHandler}
                    className="bg-secondary w-full h-10 text-white max-w-[10rem] text-center lg:text-[16px] text-[16px] uppercase pt-2.5 rounded-sm mt-5 hover:bg-gray-300 hover:text-black cursor-pointer"
                  >
                    Pay Now
                  </div>
                )}
                {!booking?.userName.includes("Offline") &&
                  user?.company?.availableLimit >
                    Math.round(booking?.priceDetails?.amount) &&
                  user?.permission?.newBooking?.Requestbooking?.permission ===
                    "DISABLE" && (
                    <div
                      onClick={async () => {
                        let resamount = await axios.get(
                          `${
                            process.env.REACT_APP_BASE_URL
                          }/bookings/currencyLayer?from=${
                            booking?.priceDetails.currency
                          }&to=USD&amount=${Math.round(
                            booking?.priceDetails.amount
                          )}`,
                          {
                            withCredentials: true,
                          }
                        );

                        if (
                          resamount?.data?.result !== null ||
                          resamount?.data?.result !== undefined
                        ) {
                          let totalUnpaidBooking =
                            user?.unpaidBooking + resamount?.data?.result;

                          let totalUnpaidBookingCompany =
                            user?.company?.totalUnpaidBooking +
                            resamount?.data?.result;

                          let availableLimitCompany =
                            user?.company?.availableLimit -
                            resamount?.data?.result;

                          dispatch(clearSourceInput());
                          dispatch(clearDestinationInput());
                          dispatch({
                            type: "CONFIRM_BOOKING_WITH_PAYMENT",
                            payload: {
                              body: {
                                bookingId: booking.bookingId,
                                bookingStatus: "CONFIRMED",
                                paymentStatus: "UNPAID",
                              },
                              token,
                              navigate,
                            },
                          });

                          dispatch({
                            type: "EDIT_USER_FOR_BOOKING",
                            payload: {
                              userId: user._id,
                              body: {
                                unpaidBooking: totalUnpaidBooking,
                              },
                              token,
                            },
                          });
                          dispatch({
                            type: "EDIT_COMPANY_FOR_BOOKING",
                            payload: {
                              companyId: user?.company?._id,
                              body: {
                                totalUnpaidBooking: totalUnpaidBookingCompany,
                                availableLimit: availableLimitCompany,
                              },
                              token,
                            },
                          });
                        }
                        // navigate(
                        //   "/newbooking/searchResult/passengerDetail/bookingSummary/bookingStatus"
                        // );
                      }}
                      className="text-white bg-secondary w-full h-10 max-w-[10rem] text-center uppercase text-[16px] pt-2.5 mx-auto rounded-sm mt-5 hover:bg-gray-300 hover:text-black cursor-pointer"
                    >
                      Pay by invoice
                    </div>
                  )}

                {/* On request BOOKING */}
                {user?.permission?.newBooking?.Requestbooking?.permission ===
                  "ENABLE" && (
                  <>
                    <div
                      onClick={() => {
                        dispatch(clearSourceInput());
                        dispatch(clearDestinationInput());
                        dispatch({
                          type: "CONFIRM_BOOKING_WITH_PAYMENT",
                          payload: {
                            body: {
                              bookingId: booking.bookingId,
                              bookingStatus: "ONREQUEST",
                              paymentStatus: "UNPAID",
                            },
                            token,
                            navigate,
                          },
                        });
                      }}
                      className="border border-secondary w-full h-10 text-primary hover:text-white max-w-[10rem] text-center uppercase  text-sm pt-2 mx-auto rounded-sm mt-5 hover:bg-secondary cursor-pointer"
                    >
                      Request Booking
                    </div>
                  </>
                )}

                {booking?.userName.includes("Offline") && (
                  <div
                    onClick={() => {
                      dispatch(clearSourceInput());
                      dispatch(clearDestinationInput());
                      dispatch({
                        type: "CONFIRM_BOOKING_WITH_PAYMENT",
                        payload: {
                          body: {
                            bookingId: booking.bookingId,
                            bookingStatus: "CONFIRMED",
                            paymentStatus: "UNPAID",
                          },
                          token,
                          navigate,
                        },
                      });

                      // navigate(
                      //   "/newbooking/searchResult/passengerDetail/bookingSummary/bookingStatus"
                      // );
                    }}
                    className=" text-white bg-secondary w-full h-10  hover:text-white max-w-[10rem] text-center uppercase  text-[16px] pt-2 mx-auto rounded-sm mt-5 hover:bg-secondary cursor-pointer"
                  >
                    Pay by invoice
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(BookingSummaryB2b);

export const PassengerDetailItem = ({ iconName, text, label }) => {
  return (
    <div className="flex items-center space-x-2">
      <FontAwesomeIcon icon={iconName} className="w-10 text-slate-600" />
      <span className="text-[15px] w-24 sm:w-40 text-black">{label}:</span>
      <div className="text-[15px] text-gray-600 font-normal">{text}</div>
    </div>
  );
};
